export default "__VITE_ASSET__BtoUWGFm__"